import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnyFieldApi } from '@tanstack/react-form';
import { UserSelectorDropDown } from '@/shared/components/user-selector';
import { useEmployees } from '@/shared/hooks';
import { FieldInfo } from '@/shared/components/form/FieldInfo';

interface AssigneeSelectorProps {
  form: any;
}

export const AssigneeSelector: React.FC<AssigneeSelectorProps> = ({ form }) => {
  const { t } = useTranslation('userSelector');

  const { data: employees = [] } = useEmployees({
    isActive: true,
    isDeleted: false,
  });

  const userSelectorEmployees = employees.map((emp) => ({
    id: emp._id,
    firstName: emp.personalInfo.firstName,
    lastName: emp.personalInfo.lastName,
    fullName: `${emp.personalInfo.firstName} ${emp.personalInfo.lastName}`,
    isActive: emp.isActive,
    imageUrl: emp.personalInfo.imageUrl,
  }));

  return (
    <form.AppField name="assignees">
      {(field: AnyFieldApi) => (
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-900">
            {t('assigneesLabel')}
          </label>
          <UserSelectorDropDown
            variant="inline"
            className={
              field.state.meta.errors.length > 0 ? 'border-red-500' : ''
            }
            employees={userSelectorEmployees}
            selectedEmployees={field.state.value}
            onSelectionChange={(selectedIds) => field.handleChange(selectedIds)}
            multiSelect={true}
            customSelectionText={
              field.state.value?.length > 0
                ? t('selectionCount')(field.state.value.length)
                : t('selectAssignees')
            }
          />

          <FieldInfo field={field} />
        </div>
      )}
    </form.AppField>
  );
};
